// CheckBox.js

import React from 'react'
import './CheckBox.css';

const CheckBox = function(props) {
    const checkClass = props.value ? "CheckBox Checked" : "CheckBox"
    return (
        <div className={checkClass}>
            <div className="CheckBoxInner"></div>
        </div>
    )
}

export default CheckBox;
